import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const SuccessStories = () => {
  const [activeStory, setActiveStory] = useState(0);

  const successStories = [
    {
      id: 'automotive-transformation',
      category: 'Transformation IA',
      company: 'AutoTech Solutions',
      industry: 'Équipementier Automobile',
      size: '2,500 employés',
      challenge: 'Intégration de l\'IA dans les processus de production et développement de véhicules connectés',
      solution: 'Programme complet de formation IA avec focus sur l\'automotive, incluant machine learning et vision par ordinateur',
      timeline: '18 mois',
      results: {
        productivity: '+145%',
        timeToMarket: '-65%',
        qualityImprovement: '+89%',
        costReduction: '€3.2M économisées',
        employeesSatisfaction: '94%'
      },
      testimonial: {
        quote: "La transformation de nos équipes grâce au programme CRF PERFECTION a dépassé toutes nos attentes. Non seulement nous avons développé des compétences techniques de pointe, mais nous avons aussi créé une culture d'innovation qui nous positionne comme leader sur notre marché.",
        author: "Marie-Claire Dubois",
        position: "Directrice Innovation & Transformation Digitale",
        image: "executive-woman-testimonial.jpg"
      },
      keyMetrics: [
        { label: 'Employés Formés', value: '847', icon: 'Users' },
        { label: 'Projets IA Lancés', value: '23', icon: 'Zap' },
        { label: 'ROI Formation', value: '340%', icon: 'TrendingUp' },
        { label: 'Temps Économisé', value: '2,400h', icon: 'Clock' }
      ],
      technologies: ['Machine Learning', 'Computer Vision', 'IoT Integration', 'Predictive Analytics', 'Neural Networks'],
      beforeAfter: {
        before: {
          title: 'Avant la Formation',
          points: ['Processus manuels chronophages', 'Réactivité limitée aux problèmes qualité', 'Développement produit traditionnel', 'Résistance aux nouvelles technologies']
        },
        after: {
          title: 'Après la Formation',
          points: ['Automatisation intelligente des processus', 'Prédiction et prévention proactive', 'Innovation continue basée sur l\'IA', 'Culture d\'adoption technologique']
        }
      }
    },
    {
      id: 'leadership-digital',
      category: 'Leadership Transformation',
      company: 'Precision Motors Group',
      industry: 'Constructeur Automobile',
      size: '12,000 employés',
      challenge: 'Transformation culturelle et leadership de la transition vers l\'électrification et l\'autonome',
      solution: 'Programme executive de leadership digital avec focus sur la conduite du changement à grande échelle',
      timeline: '24 mois',
      results: {
        productivity: '+89%',
        timeToMarket: '-45%',
        qualityImprovement: '+76%',
        costReduction: '€8.7M économisées',
        employeesSatisfaction: '91%'
      },
      testimonial: {
        quote: "Le programme de leadership digital nous a permis de réussir notre transition vers l'électrification avec une adhésion remarquable de nos équipes. Les outils et méthodologies acquis continuent de porter leurs fruits au-delà de nos objectifs initiaux.",
        author: "Jean-Philippe Martin",
        position: "CEO & Président du Directoire",
        image: "executive-man-testimonial.jpg"
      },
      keyMetrics: [
        { label: 'Leaders Formés', value: '156', icon: 'Users' },
        { label: 'Équipes Impactées', value: '89', icon: 'Target' },
        { label: 'Projets Transformation', value: '34', icon: 'RefreshCw' },
        { label: 'Satisfaction Change', value: '88%', icon: 'Heart' }
      ],
      technologies: ['Change Management', 'Digital Strategy', 'Agile Leadership', 'Data-Driven Decisions', 'Innovation Culture'],
      beforeAfter: {
        before: {
          title: 'Challenges Initiaux',
          points: ['Résistance au changement organisationnel', 'Silos entre départements', 'Vision court terme prédominante', 'Communication descendante uniquement']
        },
        after: {
          title: 'Transformation Réussie',
          points: ['Conduite proactive du changement', 'Collaboration transversale optimisée', 'Vision stratégique long terme', 'Communication bidirectionnelle efficace']
        }
      }
    },
    {
      id: 'adaptive-skills',
      category: 'Adaptabilité Organisation',
      company: 'FlexiTech Manufacturing',
      industry: 'Composants Automobiles',
      size: '5,800 employés',
      challenge: 'Développement de l\'agilité organisationnelle face aux disruptions technologiques rapides',
      solution: 'Programme d\'adaptabilité avancée avec focus sur l\'apprentissage continu et la résilience organisationnelle',
      timeline: '12 mois',
      results: {
        productivity: '+112%',
        timeToMarket: '-58%',
        qualityImprovement: '+67%',
        costReduction: '€2.1M économisées',
        employeesSatisfaction: '96%'
      },
      testimonial: {
        quote: "Grâce au programme d'adaptabilité de CRF PERFECTION, notre organisation a développé une capacité unique à se réinventer constamment. Cette agilité nous a permis de saisir des opportunités que nos concurrents ont manquées.",
        author: "Sophie Renault",
        position: "Directrice Générale Operations",
        image: "executive-woman-smile-testimonial.jpg"
      },
      keyMetrics: [
        { label: 'Collaborateurs Formés', value: '1,247', icon: 'Users' },
        { label: 'Nouvelles Compétences', value: '67', icon: 'Award' },
        { label: 'Vitesse Adaptation', value: '3.2x', icon: 'Zap' },
        { label: 'Rétention Talent', value: '97%', icon: 'Heart' }
      ],
      technologies: ['Agile Methodologies', 'Continuous Learning', 'Resilience Building', 'Innovation Mindset', 'Future Skills'],
      beforeAfter: {
        before: {
          title: 'État Initial',
          points: ['Adaptation lente aux changements', 'Formations ponctuelles traditionnelles', 'Résistance aux nouveaux processus', 'Compétences figées par fonction']
        },
        after: {
          title: 'Nouvelle Dynamique',
          points: ['Adaptation rapide et proactive', 'Apprentissage continu intégré', 'Adoption enthousiaste innovations', 'Compétences transversales développées']
        }
      }
    }
  ];

  const currentStory = successStories?.[activeStory];

  return (
    <section id="success-stories" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Témoignages de Transformation Réussie</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Découvrez comment nos programmes de développement des compétences ont permis à des organisations 
            de l'industrie automobile d'atteindre l'excellence opérationnelle et l'innovation continue.
          </p>
        </div>

        {/* Story Selector */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {successStories?.map((story, index) => (
            <button
              key={story?.id}
              onClick={() => setActiveStory(index)}
              className={`px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
                activeStory === index
                  ? 'bg-blue-600 text-white shadow-lg transform scale-105'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {story?.category}
            </button>
          ))}
        </div>

        {/* Success Story Content */}
        <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <div className="flex items-center space-x-3 mb-4">
                  <span className="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {currentStory?.category}
                  </span>
                  <span className="text-blue-200">|</span>
                  <span className="text-blue-200">{currentStory?.timeline}</span>
                </div>
                <h3 className="text-3xl font-bold mb-2">{currentStory?.company}</h3>
                <p className="text-blue-100 text-lg mb-4">{currentStory?.industry}</p>
                <div className="flex items-center space-x-4 text-blue-200">
                  <div className="flex items-center space-x-2">
                    <Icon name="Users" size={16} />
                    <span>{currentStory?.size}</span>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {currentStory?.keyMetrics?.slice(0, 4)?.map((metric, index) => (
                  <div key={index} className="text-center bg-white/10 rounded-xl p-4">
                    <Icon name={metric?.icon} size={24} className="text-white mx-auto mb-2" />
                    <div className="text-2xl font-bold text-white">{metric?.value}</div>
                    <div className="text-xs text-blue-200">{metric?.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="p-8 space-y-8">
            {/* Challenge & Solution */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-gray-900 flex items-center space-x-3">
                  <Icon name="AlertTriangle" size={24} className="text-red-600" />
                  <span>Défi Initial</span>
                </h4>
                <p className="text-gray-700 leading-relaxed">{currentStory?.challenge}</p>
              </div>
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-gray-900 flex items-center space-x-3">
                  <Icon name="Lightbulb" size={24} className="text-green-600" />
                  <span>Solution Mise en Œuvre</span>
                </h4>
                <p className="text-gray-700 leading-relaxed">{currentStory?.solution}</p>
              </div>
            </div>

            {/* Results Metrics */}
            <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-xl p-8">
              <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center">Résultats Mesurés</h4>
              <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-600 mb-2">{currentStory?.results?.productivity}</div>
                  <div className="text-sm text-gray-600">Productivité</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">{currentStory?.results?.timeToMarket}</div>
                  <div className="text-sm text-gray-600">Time to Market</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-purple-600 mb-2">{currentStory?.results?.qualityImprovement}</div>
                  <div className="text-sm text-gray-600">Amélioration Qualité</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2">{currentStory?.results?.costReduction}</div>
                  <div className="text-sm text-gray-600">Économies Réalisées</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600 mb-2">{currentStory?.results?.employeesSatisfaction}</div>
                  <div className="text-sm text-gray-600">Satisfaction Équipes</div>
                </div>
              </div>
            </div>

            {/* Before & After */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="bg-red-50 rounded-xl p-6 border-l-4 border-red-500">
                <h5 className="text-lg font-bold text-red-800 mb-4">{currentStory?.beforeAfter?.before?.title}</h5>
                <ul className="space-y-2">
                  {currentStory?.beforeAfter?.before?.points?.map((point, index) => (
                    <li key={index} className="flex items-start space-x-3 text-red-700">
                      <Icon name="X" size={16} className="text-red-500 mt-1 flex-shrink-0" />
                      <span className="text-sm">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-green-50 rounded-xl p-6 border-l-4 border-green-500">
                <h5 className="text-lg font-bold text-green-800 mb-4">{currentStory?.beforeAfter?.after?.title}</h5>
                <ul className="space-y-2">
                  {currentStory?.beforeAfter?.after?.points?.map((point, index) => (
                    <li key={index} className="flex items-start space-x-3 text-green-700">
                      <Icon name="CheckCircle" size={16} className="text-green-500 mt-1 flex-shrink-0" />
                      <span className="text-sm">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Technologies Used */}
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">Technologies et Méthodologies Appliquées</h4>
              <div className="flex flex-wrap gap-3">
                {currentStory?.technologies?.map((tech, index) => (
                  <span key={index} className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                    {tech}
                  </span>
                ))}
              </div>
            </div>

            {/* Testimonial */}
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-8">
              <div className="flex items-start space-x-6">
                <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="User" size={40} className="text-white" />
                </div>
                <div className="flex-1">
                  <blockquote className="text-lg text-gray-700 italic leading-relaxed mb-4">
                    "{currentStory?.testimonial?.quote}"
                  </blockquote>
                  <div>
                    <div className="font-bold text-gray-900">{currentStory?.testimonial?.author}</div>
                    <div className="text-blue-600 font-medium">{currentStory?.testimonial?.position}</div>
                    <div className="text-gray-600 text-sm">{currentStory?.company}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="text-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-8 text-white">
              <h4 className="text-2xl font-bold mb-4">Prêt à Transformer Votre Organisation ?</h4>
              <p className="text-blue-100 mb-6 text-lg max-w-2xl mx-auto">
                Rejoignez les leaders qui ont choisi CRF PERFECTION pour accélérer leur transformation digitale 
                et développer les compétences de demain.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors duration-200">
                  Consultation Stratégique Gratuite
                </button>
                <button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-all duration-200">
                  Étude de Cas Complète
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;